import * as React from 'react'

export const ActivityTag = ({ nameOfActivity, activityIconSrc } : {nameOfActivity: string, activityIconSrc: string}) => {
    return (
        <div className="tag__activity">
            <img src={activityIconSrc} className="tag__activity__icon" alt="" />
            <p className="tag__activity__text">{nameOfActivity}</p>
        </div>
    )
}